import React from 'react';

import LetsFishingImage from './assets/letsFishing.svg';
import { DisplayTemplate } from './display-results-template';

export const LetsFishingTemplate = () => {
  return (
    <DisplayTemplate
      image={LetsFishingImage}
      title="Let's start fishing!"
      subtitle={'You can either copy paste fishes from Facebook/Instgram or type fishes name manually'}
    />
  );
};